export const ProjectWorkRouting = [
  {
    path: "/work-manage/project-work/list",
    name: "work-manage-project-work-list",
    meta: { title: "开工报告" },
    notice: { type: "project_work_examine", hasNotice: false },
    component: () => import("@/views/work-manage/project-work/list/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-work/create",
    name: "work-manage-project-work-create",
    meta: { title: "新增开工报告",comName:"workManageProjectWorkFormCreate" },
    component: () => import("@/views/work-manage/project-work/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-work/edit/:id",
    name: "work-manage-project-work-edit",
    meta: { title: "编辑开工报告",comName:"workManageProjectWorkFormCreate" },
    component: () => import("@/views/work-manage/project-work/form-create/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-work/detail/:id",
    name: "work-manage-project-work-detail",
    meta: { title: "开工报告详情" },
    component: () => import("@/views/work-manage/project-work/form-detail/index.vue"),
  },
  {
    hidden: true,
    path: "/work-manage/project-work/flowPrint/:id",
    name: "work-manage-project-work-flow-print",
    meta: { title: "打印详情" },
    component: () => import("@/views/work-manage/project-work/flow-print/index.vue"),
  }
];
